export default __webpack_public_path__ + "static/media/outcess8.5abc2942.jpeg";